export interface CustomerFeedbackFormValues {
  positive: boolean;
  feedback: string;
  messageId: string;
}

export interface FeedbackProps {
  messageId: string;
}

export enum FeedbackFormFields {
  Feedback = "feedback",
}

export interface ContactSupportProps {
  isLoggedIn: boolean;
}
